(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["grahall-service-home"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('grahall-hero-carousel')) {
  customElements.define('grahall-hero-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-select]'));
      this.stage = this.querySelector('.ghr-carousel-stage');
      this.toggle = this.querySelector('[data-toggle]');
      this.current = 0;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.reduced.matches;
      this.hovered = false;
      this.querySelector('.ghr-carousel-controls').hidden = false;
      this.querySelector('[data-previous]').addEventListener('click', () => this.select(this.current - 1), options);
      this.querySelector('[data-next]').addEventListener('click', () => this.select(this.current + 1), options);
      this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.select(index), options));
      this.toggle.addEventListener('click', () => { this.paused = !this.paused; this.updatePlayback(); }, options);
      this.addEventListener('mouseenter', () => { this.hovered = true; this.updatePlayback(); }, options);
      this.addEventListener('mouseleave', () => { this.hovered = false; this.updatePlayback(); }, options);
      this.addEventListener('focusin', event => {
        if (!this.contains(event.relatedTarget)) {
          if (event.target === this.toggle) { clearTimeout(this.timer); }
          else { this.paused = true; this.updatePlayback(); }
        }
      }, options);
      this.reduced.addEventListener('change', event => { if (event.matches) this.paused = true; this.updatePlayback(); }, options);
      document.addEventListener('visibilitychange', () => this.updatePlayback(), options);
      this.show(0);
      this.updatePlayback();
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.controller?.abort();
      this.controller = null;
    }
    select(index) {
      this.paused = true;
      this.updatePlayback();
      this.show(index);
    }
    show(index) {
      this.current = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === this.current);
        slide.setAttribute('aria-hidden', String(i !== this.current));
        this.dots[i].setAttribute('aria-pressed', String(i === this.current));
      });
    }
    updatePlayback() {
      clearTimeout(this.timer);
      this.toggle.textContent = this.paused ? this.toggle.dataset.playText : this.toggle.dataset.pauseText;
      this.toggle.setAttribute('aria-label', this.paused ? this.toggle.dataset.playLabel : this.toggle.dataset.pauseLabel);
      this.stage.setAttribute('aria-live', this.paused ? 'polite' : 'off');
      if (!this.paused && !this.hovered && !document.hidden) {
        this.timer = setTimeout(() => { this.show(this.current + 1); this.updatePlayback(); }, 5500);
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
function setupGrahallNavigation(){
  document.querySelectorAll('.gh-site-navigation').forEach(function(root){
    if(root.dataset.navigationReady)return;
    root.dataset.navigationReady='true';
    var topMenus=root.querySelectorAll('.ghr-desktop-nav>ul>li>details');
    topMenus.forEach(function(menu){menu.addEventListener('toggle',function(){if(menu.open)topMenus.forEach(function(other){if(other!==menu)other.open=false;});});});
    root.addEventListener('keydown',function(event){if(event.key==='Escape'){var opened=event.target.closest('details[open]');if(opened){opened.open=false;opened.querySelector('summary').focus();event.preventDefault();}}});
    document.addEventListener('click',function(event){if(!root.contains(event.target))root.querySelectorAll('details[open]').forEach(function(menu){menu.open=false;});});
  });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setupGrahallNavigation);else setupGrahallNavigation();
document.addEventListener('shopify:section:load',setupGrahallNavigation);

  } catch(e) { console.error(e); }
})();
})();
